import { render, staticRenderFns } from "./afterSaleInfo.vue?vue&type=template&id=48f65166&scoped=true"
import script from "./afterSaleInfo.vue?vue&type=script&lang=js"
export * from "./afterSaleInfo.vue?vue&type=script&lang=js"
import style0 from "./afterSaleInfo.vue?vue&type=style&index=0&id=48f65166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f65166",
  null
  
)

export default component.exports